/* src/app/artic-run-diary/pages/artic-run-diary/artic-run-diary.component.scss */
.dateSelectorContainer {
  display: flex;
  justify-content: center;
  flex-flow: row wrap;
}
.dateSelectorContainer button {
  background: transparent;
  border: 0;
  box-shadow: none;
}
.dateSelectorContainer i {
  font-size: 2rem;
}
.dateSelectorContainer i:hover {
  color: #2196f3;
  cursor: pointer;
}
.datePicker {
  display: inline-block;
  position: absolute;
  left: 42rem;
  top: 7rem;
}
.dateSelectorBox {
  background-color: transparent;
  padding: 0.3rem;
  width: 20rem;
  font-size: 1.2rem;
  text-align: center;
  margin-top: 0.7rem;
  color: #34495e;
  font-weight: bold;
}
.dateSelectorBox:hover {
  color: #2196f3;
  cursor: pointer;
}
.gridPagination {
  width: 100%;
}
.gridPagination ul {
  display: table;
  margin: 0 auto;
  list-style-type: none;
}
.gridPagination li {
  display: inline-block;
}
.gridPagination li a.active {
  text-decoration: underline;
}
table td {
  color: white;
}
/*# sourceMappingURL=artic-run-diary.component.css.map */
